import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import HowItWorks from "@/components/landing/HowItWorks";
import CapitalRatio from "@/components/landing/CapitalRatio";
import LiquidityBoard from "@/components/landing/LiquidityBoard";
import Opportunities from "@/components/landing/Opportunities";
import Calculator from "@/components/landing/Calculator";
import Benefits from "@/components/landing/Benefits";
import TrustStats from "@/components/landing/TrustStats";
import LeadForm from "@/components/landing/LeadForm";
import Faq from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";
import ScripDetail from "@/pages/ScripDetail";

const Landing = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <HowItWorks />
      <CapitalRatio />
      <LiquidityBoard />
      <Opportunities />
      <Calculator />
      <Benefits />
      <TrustStats />
      <LeadForm />
      <Faq />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="min-h-screen bg-[#f8fafc] text-slate-900 overflow-x-clip">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/scrip/:scripId" element={<ScripDetail />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
